<template>
	<div v-if="$root.loading"></div>
	<div v-else>
	  <div ref="document">
	    <basic/>
	    <div v-for="(item, index) in $root.products">
	      <component 
	        :is="item.template" 
	        :index = "index+1"
	        :license_period="item.license_period"
	        :license_count="item.license_count" 
	        :license_price="item.license_price"
	        :license_user_count="item.license_user_count" 
	        :license_total_sum="item.license_total_sum"
	      />
	    </div>
	  </div>
	  <Save_instruction/>
	</div>
</template>

<script>
import basic from '../templates/basic.vue'
import seldon_1_7 from '../templates/seldon_1_7.vue'
import seldon_1_7_start from '../templates/seldon_1_7_start.vue'
import seldon_1_7_optimal from '../templates/seldon_1_7_optimal.vue'
import seldon_1_7_business from '../templates/seldon_1_7_business.vue'
import seldon_1_7_premium from '../templates/seldon_1_7_premium.vue'
import seldon_basis from '../templates/seldon_basis.vue'
import seldon_pro from '../templates/seldon_pro.vue'
import seldon_price from '../templates/seldon_price.vue'
import seldon_doc from '../templates/seldon_doc.vue'
import seldon_lite from '../templates/seldon_lite.vue'
import Save_instruction from '../../Save_instruction.vue'


export default{
  components: {
	basic,
	seldon_1_7,
	seldon_1_7_start,
	seldon_1_7_optimal,
	seldon_1_7_business,
	seldon_1_7_premium,
	seldon_basis,
	seldon_pro,
	seldon_price,
	seldon_doc,
	seldon_lite,
	Save_instruction,
	},

	mounted(){
		if(!this.$root.document_number){
			this.$router.push('/documents/'+this.$route.params.id)
		}
		document.title = "Договор_"+this.$root.document_number;
	},
}	

</script>